import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionDataService } from 'inova-front-core/session';


@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private router: Router,private sessionService:SessionDataService) {}

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let role=this.sessionService.getUserRole();
    const roleRequired=route.data.roleRequired
    if (Array.isArray(roleRequired) && roleRequired.some(x=>x.toLowerCase()==role.toLowerCase())) {
        return true;
    }
    if(!this.sessionService.isLoggedIn()){
      this.sessionService.localLogout(true);
    }
    if(route.data.redirectTo){
      this.router.navigate(route.data.redirectTo);
    }
    else{
      this.router.navigate(['./role-check']);
    }
    return false;
  }

}
